import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import { useTranslation } from "react-i18next";
import SetPasswordForm from "../../features/auth/components/SetPasswordForm";
import type { RootState } from "../../common/state/store";
import type { ISetPasswordFormData } from "../../features/auth/state/authSlice";
import { setInitialPassword } from "../../features/auth/state/authSlice";
import { loadingSelector, LoadingState } from "../../common/state/slice/appStateSlice";
import { jwtSelector } from "../../common/state/selectors/authSelector";

export const SET_PASSWORD_COMPONENTID = "setPasswordComponent";

const SetPassword = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [setPasswordToken, setSetPasswordToken] = React.useState("");
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
  const [redirecting, setRedirecting] = React.useState(false);

  const { loading, jwt } = useAppSelector((state: RootState) => {
    return {
      loading: loadingSelector(state, SET_PASSWORD_COMPONENTID),
      jwt: jwtSelector(state),
    };
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const langParam = params.get("lang");

    const targetLang = langParam === "en" ? "en" : "fr";

    console.log(`[SetPassword] URL lang param: "${langParam}", setting language to: ${targetLang}`);
    void i18n.changeLanguage(targetLang);
  }, [location.search, i18n]);

  useEffect(() => {
    const code = new URLSearchParams(location.search).get("code");
    if (code) {
      setSetPasswordToken(code);
    } else {
      setRedirecting(true);
      setTimeout(() => navigate(jwt ? "/" : "/login"), 2000);
    }
  }, [location.search, navigate, jwt]);

  useEffect(() => {
    if (loading && loading === LoadingState.Success) {
      setShowSuccessMessage(true);
      setTimeout(() => navigate(jwt ? "/" : "/login"), 2000);
    }
  }, [loading, navigate, jwt]);

  const handleSubmit = (data: ISetPasswordFormData) => {
    void dispatch(
      setInitialPassword({
        componentId: SET_PASSWORD_COMPONENTID,
        code: setPasswordToken,
        ...data,
      }),
    );
  };

  if (redirecting) {
    return (
      <div className="bg-slate-100 flex h-screen">
        <div className="flex flex-1 max-w-xs md:max-w-lg mx-auto items-center justify-center">
          <div className="border flex flex-col bg-white border-gray-200 rounded-lg shadow-md py-6 px-8 text-center">
            <p className="text-lg text-gray-700">
              {t(
                "pages.setPassword.invalidLink",
                "Lien invalide. Redirection vers la page de connexion...",
              )}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <SetPasswordForm
      onSubmit={handleSubmit}
      loading={loading}
      showSuccessMessage={showSuccessMessage}
    />
  );
};

export default SetPassword;
